"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Conversion = void 0;
var Conversion;
(function (Conversion) {
    /** delete the associated field of the associated table */
    Conversion["Delete"] = "delete";
    /** Keep the associated fields of the associated table and convert them to text type */
    Conversion["KeepText"] = "keepText";
})(Conversion = exports.Conversion || (exports.Conversion = {}));
//# sourceMappingURL=open_field_write_types.js.map